module.exports = __webpack_public_path__ + "static/car-pc/img/PK.84f03aa0.svg";